import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Api from '../api';

const AcknowledgeOfTermsForm = ({ jobId, next, refetchContract, setPending }) => {
  const canvas = React.useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (canvas.current.isEmpty()) return;

    const sign = canvas.current?.toDataURL('base64');

    setPending(true);

    try {
      await Api.sign(jobId, sign, 'ld_contract_acknowledge_client');
      await refetchContract();
      next();
    } catch (e) {}

    setPending(false);
  };

  return (
    <form id="ld-contract-invoice-modal" onSubmit={handleSubmit}>
      <div className="ld-contract-invoice-modal-body">
        <div className="new-table">
          <div className="new-table--row">
            <div className="new-table--row--item select light">
              <label className="ld-contract-invoice-modal-label">Sign Here</label>
            </div>
          </div>
          <div className="new-table--row">
            <div className="new-table--row--item no-padding">
              <SignatureCanvas ref={canvas} canvasProps={{ className: 'ld-contract-invoice-modal-sign-field' }} />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default AcknowledgeOfTermsForm;
